import React from "react";

const Results = ({ isOpen, total, closePopup, date }) => {
    // 1. Nếu popup chưa mở thì không render gì cả
    if (!isOpen) {
        return null;
    }

    // 2. Lấy dữ liệu an toàn
    // Nếu total chưa có hoặc rỗng, data sẽ là null
    const data = (total && total.length > 0) ? total[0] : null;

    // 3. Xử lý trường hợp chưa có dữ liệu (Hiển thị Loading để tránh crash)
    if (!data) {
        return (
            <div className="popup-backdrop">
                <div className="popup-main">
                    <div className="popup-header">Kết quả phiên {date}</div>
                    <div className="popup-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '150px' }}>
                        <div className="loader" style={{ marginBottom: '10px' }}></div>
                        <p>Đang cập nhật dữ liệu...</p>
                    </div>
                    <button
                        onClick={closePopup}
                        className="popup-close"
                        style={{
                            background: "#fef8a1", // Giữ nguyên màu nút của bạn
                            boxShadow: "none",
                            textShadow: "none"
                        }}>
                        Đóng
                    </button>
                </div>
            </div>
        );
    }

    // 4. Render bảng kết quả khi đã có data (Dùng data?. để an toàn)
    return (
        <div className="popup-backdrop">
            <div className="popup-main">
                <div className="popup-header">Kết quả phiên {date}</div>
                <div className="popup-content" style={{ padding: "0" }}>
                    <table id="table-xsmb" className="table-result table table-bordered table-striped table-xsmb">
                        <tbody>
                            <tr>
                                <th style={{ width: "10%" }}>ĐB</th>
                                <td>
                                    <span id="mb_prize_0" className="special-prize div-horizontal">
                                        {data?.dacbiet}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>1</th>
                                <td>
                                    <span id="mb_prize_1" className="prize1 div-horizontal">
                                        {data?.nhat}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>2</th>
                                <td>
                                    <span id="mb_prize_2" className="prize2 div-horizontal">
                                        {data?.hai?.split(" ")[0]}
                                    </span>
                                    <span id="mb_prize_3" className="prize2 div-horizontal">
                                        {data?.hai?.split(" ")[1]}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>3</th>
                                <td>
                                    <span id="mb_prize_4" className="prize3 div-horizontal">
                                        {data?.ba?.split(" ")[0]}
                                    </span>
                                    <span id="mb_prize_5" className="prize3 div-horizontal">
                                        {data?.ba?.split(" ")[1]}
                                    </span>
                                    <span id="mb_prize_6" className="prize3 div-horizontal">
                                        {data?.ba?.split(" ")[2]}
                                    </span>
                                    <span id="mb_prize_7" className="prize3 div-horizontal">
                                        {data?.ba?.split(" ")[3]}
                                    </span>
                                    <span id="mb_prize_8" className="prize3 div-horizontal">
                                        {data?.ba?.split(" ")[4]}
                                    </span>
                                    <span id="mb_prize_9" className="prize3 div-horizontal">
                                        {data?.ba?.split(" ")[5]}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>4</th>
                                <td>
                                    <span id="mb_prize_10" className="prize4 div-horizontal">
                                        {data?.tu?.split(" ")[0]}
                                    </span>
                                    <span id="mb_prize_11" className="prize4 div-horizontal">
                                        {data?.tu?.split(" ")[1]}
                                    </span>
                                    <span id="mb_prize_12" className="prize4 div-horizontal">
                                        {data?.tu?.split(" ")[2]}
                                    </span>
                                    <span id="mb_prize_13" className="prize4 div-horizontal">
                                        {data?.tu?.split(" ")[3]}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>5</th>
                                <td>
                                    <span id="mb_prize_14" className="prize5 div-horizontal">
                                        {data?.nam?.split(" ")[0]}
                                    </span>
                                    <span id="mb_prize_15" className="prize5 div-horizontal">
                                        {data?.nam?.split(" ")[1]}
                                    </span>
                                    <span id="mb_prize_16" className="prize5 div-horizontal">
                                        {data?.nam?.split(" ")[2]}
                                    </span>
                                    <span id="mb_prize_17" className="prize5 div-horizontal">
                                        {data?.nam?.split(" ")[3]}
                                    </span>
                                    <span id="mb_prize_18" className="prize5 div-horizontal">
                                        {data?.nam?.split(" ")[4]}
                                    </span>
                                    <span id="mb_prize_19" className="prize5 div-horizontal">
                                        {data?.nam?.split(" ")[5]}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>6</th>
                                <td>
                                    <span id="mb_prize_20" className="prize6 div-horizontal">
                                        {data?.sau?.split(" ")[0]}
                                    </span>
                                    <span id="mb_prize_21" className="prize6 div-horizontal">
                                        {data?.sau?.split(" ")[1]}
                                    </span>
                                    <span id="mb_prize_22" className="prize6 div-horizontal">
                                        {data?.sau?.split(" ")[2]}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>7</th>
                                <td>
                                    <span id="mb_prize_23" className="prize7 div-horizontal">
                                        {data?.bay?.split(" ")[0]}
                                    </span>
                                    <span id="mb_prize_24" className="prize7 div-horizontal">
                                        {data?.bay?.split(" ")[1]}
                                    </span>
                                    <span id="mb_prize_25" className="prize7 div-horizontal">
                                        {data?.bay?.split(" ")[2]}
                                    </span>
                                    <span id="mb_prize_26" className="prize7 div-horizontal">
                                        {data?.bay?.split(" ")[3]}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button
                    onClick={closePopup}
                    className="popup-close"
                    style={{
                        background: "#219750", // Giữ nguyên màu nút của bạn
                        boxShadow: "none",
                        textShadow: "none"
                    }}>
                    Đóng
                </button>
            </div>
        </div>
    );
};

export default Results;